import { useEffect, useRef, useState } from "react";
import { api, ApiError, listSnapshots, snapshotRecords } from "../api";
import { useStore } from "../state/store";

export function ProfileMenu({ onSignOut }: { onSignOut: () => void }) {
  const { profile, layout } = useStore();
  const [open, setOpen] = useState(false);
  const [changing, setChanging] = useState(false);
  const [current, setCurrent] = useState(""); const [next, setNext] = useState(""); const [msg, setMsg] = useState("");
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => { const close = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); }; document.addEventListener("mousedown", close); return () => document.removeEventListener("mousedown", close); }, []);

  async function exportAll() {
    const inv = await listSnapshots().catch(() => null);
    const payload = { format: "dm-screen-export", version: 1, exportedAt: new Date().toISOString(), site: { host: location.host }, profile, layout, inventorySnapshots: snapshotRecords(inv) };
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([JSON.stringify(payload)], { type: "application/json" }));
    a.download = `dm-screen-export-${new Date().toISOString().replace(/[:T]/g, "-").slice(0, 16)}.json`;
    document.body.appendChild(a); a.click(); a.remove();
  }
  async function changePassword(e: React.FormEvent) {
    e.preventDefault(); setMsg("");
    try { await api("/api/profiles/password", { method: "POST", body: JSON.stringify({ currentPassword: current, newPassword: next }) }); setMsg("Password changed."); setCurrent(""); setNext(""); setChanging(false); }
    catch (err) { setMsg(err instanceof ApiError ? err.message : "Could not change the password"); }
  }

  return (
    <div className="profile-menu" ref={ref}>
      <button className="ghost small" onClick={() => setOpen((v) => !v)} aria-haspopup="menu" aria-expanded={open}>{profile.displayName} ▾</button>
      {open && (
        <div className="menu" role="menu">
          <div className="muted small">@{profile.username}</div>
          <button role="menuitem" onClick={exportAll}>⇩ Export console state (JSON)</button>
          <a role="menuitem" href="/import.html">⇧ Import an export file</a>
          <button role="menuitem" onClick={() => setChanging((v) => !v)}>Change password</button>
          {changing && <form onSubmit={changePassword} className="pw-form"><input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} placeholder="Current password" autoComplete="current-password" required /><input type="password" value={next} onChange={(e) => setNext(e.target.value)} placeholder="New password (8+)" autoComplete="new-password" minLength={8} required /><button type="submit" className="small primary">Save</button></form>}
          {msg && <div className="small">{msg}</div>}
          <button role="menuitem" onClick={onSignOut}>Sign out</button>
        </div>
      )}
    </div>
  );
}
